export const Genres = [
  "12-bar blues",
  "2 tone",
  "2-step garage",
  "4-beat",
  "50s progression",
  "a cappella",
  "accordion",
  "acid breaks",
  "acid house",
  "acid jazz",
  "acid rock",
  "acid techno",
  "acid trance",
  "acousmatic music",
  "acoustic",
  "adult contemporary",
  "african",
  "african blues",
  "african heavy metal",
  "african hip hop",
  "african-american",
  "afro cosmic disco",
  "afro-cuban jazz",
  "afrobeat",
  "afropop",
  "aggrotech",
  "aleatoric",
  "algerian",
  "alternative",
  "alternative country",
  "alternative dance",
  "alternative hip hop",
  "alternative metal",
  "alternative r&b",
  "alternative rock",
  "amami islands",
  "ambient",
  "ambient dub",
  "ambient house",
  "ambient music",
  "american folk revival",
  "americana",
  "anarchist",
  "anarcho punk",
  "anarcho-punk",
  "anasheed",
  "anatolian rock",
  "ancient",
  "anime",
  "anti-folk",
  "apala",
  "appalachian folk music",
  "arab pop",
  "arabic pop",
  "argentine rock",
  "ars antiqua",
  "ars nova",
  "ars subtilior",
  "art pop",
  "art punk",
  "art rock",
  "ashik",
  "asian",
  "asian american jazz",
  "asian underground",
  "assyrian pop music",
  "atlanta hip hop",
  "australian aboriginal",
  "australian country",
  "australian country music",
  "australian hip hop",
  "australian pub rock",
  "austropop",
  "avant-garde",
  "avant-garde jazz",
  "avant-garde metal",
  "avant-punk",
  "axé",
  "bachata",
  "background music",
  "baggy",
  "bahrain",
  "baila",
  "baisha xiyue",
  "baithak gana",
  "baião",
  "bajourou",
  "bakersfield sound",
  "bal-musette",
  "balakadri",
  "balearic beat",
  "balearic trance",
  "balinese gamelan",
  "balkan brass band",
  "ballad",
  "ballata",
  "ballet",
  "baltimore club",
  "bambuco",
  "banda",
  "bangsawan",
  "bantowbol",
  "barbadian",
  "barbershop",
  "barn dance",
  "baroque",
  "baroque pop",
  "basque",
  "bass",
  "bassline",
  "batucada",
  "batá-rumba",
  "baul",
  "beach",
  "beat",
  "beat music",
  "beatboxing",
  "beautiful",
  "beautiful music",
  "bebop",
  "beiguan",
  "bel canto",
  "belizean",
  "bend-skin",
  "benga",
  "bent edge",
  "berlin school",
  "bhajan",
  "bhangra",
  "bhangragga",
  "big band",
  "big beat",
  "big room",
  "biguine",
  "bihu",
  "bikutsi",
  "biomusic",
  "bitpop",
  "black metal",
  "black midi",
  "blackened death metal",
  "blue-eyed soul",
  "bluegrass",
  "blues",
  "blues ballad",
  "blues country",
  "blues rock",
  "blues shouter",
  "boi",
  "bolero",
  "bolivia",
  "bongo flava",
  "boogaloo",
  "boogie",
  "boogie-woogie",
  "bosnian",
  "bossa nova",
  "bounce",
  "bounce music",
  "bouncy house",
  "bouncy techno",
  "bouyon",
  "brass",
  "brazilian",
  "brazilian rock",
  "breakbeat",
  "breakbeat hardcore",
  "breakcore",
  "breakstep",
  "brega",
  "breton",
  "brick city club",
  "brill building",
  "brill building sound",
  "brit funk",
  "british",
  "british blues",
  "british dance band",
  "british folk revival",
  "british hip hop",
  "british invasion",
  "britpop",
  "broken beat",
  "brostep",
  "brown-eyed soul",
  "brukdown",
  "bubblegum dance",
  "bubblegum pop",
  "buddhist",
  "bulerías",
  "bullerengue",
  "bunraku",
  "burger-highlife",
  "burgundian school",
  "bush ballad",
  "byzantine",
  "c-pop",
  "ca din tulnic",
  "ca trù",
  "cabaret",
  "cadence rampa",
  "cadence-lypso",
  "cajun",
  "cajun fiddle tunes",
  "calinda",
  "calypso",
  "calypso-style baila",
  "campursari",
  "canadian blues",
  "canción",
  "candombe",
  "canon",
  "cantata",
  "cante chico",
  "cante jondo",
  "canterbury scene",
  "cantiga",
  "cantiñas",
  "canto livre",
  "cantopop",
  "canzone",
  "canzone napoletana",
  "cape jazz",
  "capoeira",
  "caribbean and caribbean-influenced",
  "cariso",
  "carnatic",
  "carol",
  "cartageneras",
  "cavacha",
  "celempungan",
  "cello rock",
  "celtic",
  "celtic fusion",
  "celtic hip hop",
  "celtic metal",
  "celtic music",
  "celtic punk",
  "celtic reggae",
  "celtic rock",
  "cha cha cha",
  "cha-cha-cha",
  "chacarera",
  "chakacha",
  "chalga",
  "chamamé",
  "chamber",
  "chamber jazz",
  "chamber music",
  "chamber pop",
  "champeta",
  "changuí",
  "changüí",
  "chanson",
  "chant",
  "chanting",
  "chap hop",
  "charanga",
  "charanga-vallenata",
  "charikawi",
  "chastushka",
  "chicago blues",
  "chicago hip hop",
  "chicago house",
  "chicago soul",
  "chicano rap",
  "chicha",
  "chicken scratch",
  "children's music",
  "chill-out",
  "chillstep",
  "chillwave",
  "chimurenga",
  "chinese music",
  "chinese rock",
  "chiptune",
  "chopped and screwed",
  "choro",
  "chouval bwa",
  "chowtal",
  "christian alternative rock",
  "christian black metal",
  "christian country",
  "christian country music",
  "christian electronic",
  "christian hardcore",
  "christian hip hop",
  "christian metal",
  "christian music",
  "christian pop",
  "christian punk",
  "christian rock",
  "christian ska",
  "christmas carol",
  "christmas carols",
  "christmas music",
  "chumba",
  "church music",
  "chut-kai-pang",
  "chutney",
  "chutney soca",
  "chylandyk",
  "chèo",
  "chầu văn",
  "classic country",
  "classic female blues",
  "classical",
  "classical crossover",
  "classical music",
  "classical period",
  "close harmony",
  "coladeira",
  "coldwave",
  "combined rhythm",
  "comedy",
  "comedy music",
  "comedy rap",
  "comedy rock",
  "comic opera",
  "compas",
  "complextro",
  "concerto",
  "concerto grosso",
  "conga",
  "congolese rumba",
  "conjunto",
  "conscious hip hop",
  "contemporary christian music",
  "contemporary folk",
  "contemporary r&b",
  "continental jazz",
  "contradanza",
  "cool jazz",
  "coon song",
  "corrido",
  "country",
  "country blues",
  "country folk",
  "country music",
  "country pop",
  "country rap",
  "country rock",
  "country-rap",
  "coupé-décalé",
  "cowboy western music",
  "cowpunk",
  "creole",
  "cretan",
  "criolla",
  "crossover jazz",
  "crossover thrash",
  "crunk",
  "crunkcore",
  "crust punk",
  "crustgrind",
  "csárdás",
  "cuarteto",
  "cuban",
  "cueca",
  "cumbia",
  "cumbia rap",
  "cumbia villera",
  "cybergrind",
  "cải lương",
  "d-beat",
  "dabke",
  "dadra",
  "dadra tala",
  "daina",
  "dance",
  "dance music",
  "dance-pop",
  "dance-punk",
  "dance-rock",
  "dancehall",
  "dancehall music",
  "dangdut",
  "danger",
  "danish",
  "dansband",
  "dansband music",
  "danza",
  "danzón",
  "dappan koothu",
  "dark ambient",
  "dark cabaret",
  "dark electro",
  "dark pop",
  "dark rock",
  "dark wave",
  "darkcore",
  "darkcore jungle",
  "darkstep",
  "de dragote",
  "death",
  "death 'n' roll",
  "death industrial",
  "death metal",
  "death rock",
  "death-doom",
  "deathcore",
  "deathgrind",
  "deathrock",
  "deep funk",
  "deep house",
  "delta blues",
  "dementia",
  "descarga",
  "desert rock",
  "desi",
  "detroit blues",
  "detroit hip hop",
  "detroit techno",
  "dhamar",
  "dhrupad",
  "dhun",
  "digital hardcore",
  "dirge",
  "dirty rap",
  "disco",
  "disco polo",
  "diva house",
  "dixieland",
  "djent",
  "doina",
  "dondang sayang",
  "donegal fiddle tradition",
  "dongjing",
  "doo-wop",
  "doom metal",
  "doomcore",
  "downtempo",
  "dream pop",
  "dream trance",
  "drill",
  "drill and bass",
  "drill music",
  "drone",
  "drone metal",
  "drone music",
  "drum and bass",
  "drumstep",
  "dub",
  "dub techno",
  "dubstep",
  "dubstyle",
  "dubtronica",
  "dunedin sound",
  "dunun",
  "dutch house",
  "dutch jazz",
  "décima",
  "early",
  "east coast blues",
  "east coast hip hop",
  "easy listening",
  "electric blues",
  "electric folk",
  "electro",
  "electro backbeat",
  "electro house",
  "electro music",
  "electro swing",
  "electro-industrial",
  "electroacoustic",
  "electroacoustic music",
  "electroclash",
  "electronic",
  "electronic body music",
  "electronic dance",
  "electronic dance music",
  "electronic music",
  "electronic rock",
  "electronica",
  "electronicore",
  "electropop",
  "electropunk",
  "elevator music",
  "emo",
  "emo pop",
  "enka",
  "epic",
  "eremwu eu",
  "ethereal wave",
  "ethnic electronica",
  "ethno jazz",
  "euro disco",
  "euro house",
  "eurobeat",
  "eurodance",
  "european",
  "european classical",
  "european free jazz",
  "europop",
  "eurotrance",
  "exotica",
  "experimental",
  "experimental hip hop",
  "experimental music",
  "experimental pop",
  "experimental rock",
  "extreme metal",
  "fado",
  "falak",
  "fandango",
  "fann at-tanbura",
  "farruca",
  "fiddle",
  "fidget house",
  "fijiri",
  "filk",
  "filk music",
  "film",
  "film score",
  "filmi",
  "filmi-ghazal",
  "fingerstyle",
  "finnish",
  "flamenco",
  "florida breaks",
  "folk",
  "folk jazz",
  "folk metal",
  "folk music",
  "folk pop",
  "folk punk",
  "folk rock",
  "folktronica",
  "forró",
  "franco-country",
  "freak folk",
  "freakbeat",
  "free funk",
  "free improvisation",
  "free jazz",
  "free tekno",
  "freestyle",
  "freestyle music",
  "freestyle rap",
  "french caribbean",
  "french house",
  "french pop",
  "frevo",
  "fuji",
  "fuji music",
  "full on",
  "full on trance",
  "funaná",
  "funeral doom",
  "funk",
  "funk carioca",
  "funk metal",
  "funk rock",
  "funkadelic",
  "funkstep",
  "funktronica",
  "funky house",
  "furniture music",
  "fusion jazz",
  "future bass",
  "future garage",
  "future house",
  "futurepop",
  "g-funk",
  "gaana",
  "gabba",
  "gabber",
  "gagaku",
  "gaita zuliana",
  "galant",
  "game boy music",
  "gamelan",
  "gamelan bebonangan",
  "gamelan degung",
  "gamelan gong kebyar",
  "gamelan salendro",
  "gamelan selunding",
  "gamelan semar pegulingan",
  "gammaldans",
  "gandrung",
  "gangsta rap",
  "gangster rap",
  "gar",
  "garage house",
  "garage punk",
  "garage rock",
  "garba",
  "garifuna",
  "garifuna music",
  "gavotte",
  "gender wayang",
  "genge",
  "genoese",
  "german folk",
  "ghazal",
  "ghetto house",
  "ghettotech",
  "girl group",
  "glam metal",
  "glam punk",
  "glam rock",
  "glitch",
  "glitch hop",
  "gnawa",
  "go-go",
  "goa trance",
  "golden age hip hop",
  "gong chime",
  "goombay",
  "goregrind",
  "goshu ondo",
  "gospel",
  "gospel blues",
  "gothic metal",
  "gothic rock",
  "grebo",
  "gregorian chant",
  "grime",
  "grindcore",
  "grindie",
  "groove metal",
  "group sounds",
  "grunge",
  "grupera",
  "guadeloupean",
  "guajira",
  "gumbe",
  "gunchei",
  "gunka",
  "guoyue",
  "gwo ka",
  "gwo ka moderne",
  "gypsy jazz",
  "gypsy punk",
  "habanera",
  "hakka",
  "halling",
  "hambo",
  "hamburger schule",
  "hammond organ",
  "happy hardcore",
  "haqibah",
  "hard bop",
  "hard house",
  "hard nrg",
  "hard rock",
  "hard trance",
  "hardbag",
  "hardcore",
  "hardcore hip hop",
  "hardcore punk",
  "hardcore techno",
  "hardstep",
  "hardstyle",
  "harmonica blues",
  "hasapiko",
  "hawaiian",
  "heartland rock",
  "heavy metal",
  "hellbilly music",
  "hi-nrg",
  "highlife",
  "hill country blues",
  "hindustani",
  "hindustani classical",
  "hip hop",
  "hip hop music",
  "hip hop soul",
  "hip house",
  "hip pop",
  "hiplife",
  "hiragasy",
  "hokum",
  "hokum blues",
  "hong kong",
  "honky tonk",
  "honky-tonk",
  "honkyoku",
  "hora lungă",
  "hornpipe",
  "horror punk",
  "horrorcore",
  "house",
  "house music",
  "houston hip hop",
  "huayno",
  "huayño",
  "hula",
  "humppa",
  "hunguhungu",
  "hyangak",
  "hymn",
  "hyphy",
  "hát tuồng",
  "icaro",
  "icelandic",
  "idm",
  "igbo",
  "igbo highlife",
  "igbo rap",
  "illbient",
  "impressionist",
  "improvisational",
  "incidental",
  "india",
  "indian classical music",
  "indian music",
  "indian pop",
  "indie",
  "indie folk",
  "indie pop",
  "indie rock",
  "indietronica",
  "indo jazz",
  "industrial",
  "industrial death metal",
  "industrial folk",
  "industrial hip hop",
  "industrial metal",
  "industrial music",
  "industrial musical",
  "industrial rock",
  "instrumental",
  "instrumental country",
  "instrumental hip hop",
  "instrumental rock",
  "intelligent dance",
  "inuit",
  "iranian pop",
  "irish",
  "irish folk",
  "irish rebel",
  "isicathamiya",
  "islamic music",
  "isolationism",
  "isolationist",
  "italo dance",
  "italo disco",
  "italo house",
  "izvorna bosanska",
  "j-pop",
  "j-rock",
  "jaipongan",
  "jam",
  "jamrieng samai",
  "jangle pop",
  "japanese",
  "japanoise",
  "jarana yucateca",
  "jarocho",
  "jawaiian",
  "jazz",
  "jazz blues",
  "jazz fusion",
  "jazz house",
  "jazz rap",
  "jazz rock",
  "jazz-funk",
  "jegog",
  "jenkka",
  "jerkin'",
  "jersey club",
  "jesus",
  "jig",
  "jing ping",
  "jingle",
  "jit",
  "jitterbug",
  "jive",
  "joged",
  "joged bumbung",
  "joik",
  "joropo",
  "jota",
  "jug",
  "juke joint blues",
  "jump blues",
  "jump-up",
  "jumpstyle",
  "jungle",
  "junkanoo",
  "jùjú",
  "k-pop",
  "kaba",
  "kabuki",
  "kacapi suling",
  "kachāshī",
  "kadongo kamu",
  "kagok",
  "kaiso",
  "kalamatianó",
  "kan ha diskan",
  "kansas city blues",
  "kansas city jazz",
  "kantrum",
  "kapuka",
  "kargyraa",
  "kaseko",
  "kawachi ondo",
  "kayōkyoku",
  "kecak",
  "kerala",
  "keroncong",
  "kertok",
  "khaleeji",
  "khaliji",
  "khene",
  "khoomei",
  "khyal",
  "kirtan",
  "kiwi rock",
  "kizomba",
  "klapa",
  "klasik",
  "klezmer",
  "kliningan",
  "kolomyjka",
  "komagaku",
  "korea",
  "korean",
  "kpanlogo",
  "kpop",
  "krakowiak",
  "krautrock",
  "kriti",
  "kroncong",
  "kuduro",
  "kulintang",
  "kundiman",
  "kuwait",
  "kvæði",
  "kwaito",
  "kwassa kwassa",
  "kwela",
  "lambada",
  "laptronica",
  "latin",
  "latin alternative",
  "latin american",
  "latin ballad",
  "latin christian",
  "latin house",
  "latin jazz",
  "latin metal",
  "latin music",
  "latin pop",
  "latin rock",
  "latin swing",
  "lavani",
  "laïkó",
  "legényes",
  "lento violento",
  "letkajenkka",
  "lhamo",
  "lied",
  "light",
  "liquid dubstep",
  "liquid funk",
  "liquindi",
  "livetronica",
  "liwa",
  "lo-fi",
  "logobi",
  "long song",
  "louisiana blues",
  "louisiana swamp pop",
  "louisianan",
  "lounge",
  "lounge music",
  "lovers rock",
  "low bap",
  "lowercase",
  "lu",
  "lubbock sound",
  "luk krung",
  "luk thung",
  "lullaby",
  "lundu",
  "lust",
  "lyrical hip hop",
  "m-base",
  "madchester",
  "madrigal",
  "mafioso rap",
  "mahori",
  "mainstream jazz",
  "makossa",
  "malacca",
  "malaysia",
  "malaysian",
  "malhun",
  "maloya",
  "mambo",
  "manaschi",
  "mandarin",
  "mandopop",
  "manele",
  "mangue bit",
  "manila sound",
  "mapouka",
  "marabi",
  "maracatu",
  "marathi",
  "mariachi",
  "marinera",
  "marrabenta",
  "martial industrial",
  "martinetes",
  "maskanda",
  "mass",
  "matamuerte",
  "math rock",
  "mathcore",
  "maxixe",
  "mazurka",
  "mbalax",
  "mbaqanga",
  "mbube",
  "medieval",
  "medieval folk rock",
  "medieval metal",
  "meditation",
  "meiji restoration",
  "mejoranera",
  "melam",
  "melbourne bounce",
  "melodic",
  "melodic death metal",
  "melodic hardcore",
  "melodic metalcore",
  "memphis blues",
  "memphis soul",
  "mento",
  "merengue",
  "merengue típico",
  "merenrap",
  "metal",
  "metalcore",
  "mexican pop",
  "mexican rock",
  "mexican son",
  "meykhana",
  "mezwed",
  "miami bass",
  "microhouse",
  "middle ages",
  "middle eastern music",
  "middle of the road",
  "midwest hip hop",
  "milonga",
  "min'yō",
  "minangkabau",
  "mini-jazz",
  "minimal",
  "minimal techno",
  "minimal trance",
  "minimal wave",
  "minneapolis sound",
  "minstrel",
  "minuet",
  "mississippi delta",
  "modal jazz",
  "modern classical",
  "modern laïka",
  "modern rock",
  "modinha",
  "montuno",
  "moombahcore",
  "moombahton",
  "mor lam",
  "mor lam sing",
  "morlam",
  "morna",
  "mosambique",
  "motown",
  "motswako",
  "mozambique",
  "mozambique of america",
  "mozambique of cuba",
  "mugham",
  "murga",
  "musette",
  "mushroom jazz",
  "music",
  "music drama",
  "music hall",
  "musica llanero",
  "musical improvisation",
  "musiqi-e assil",
  "musique concrète",
  "muwashshah",
  "mákina",
  "méringue",
  "música criolla",
  "música popular brasileira",
  "música sertaneja",
  "nagauta",
  "nagoya kei",
  "nakasi",
  "nangma",
  "nanguan music",
  "narcocorrido",
  "nardcore",
  "narodna muzika",
  "nashville sound",
  "national socialist black metal",
  "native american music",
  "ndombolo",
  "neapolitan",
  "nederpop",
  "neo kyma",
  "neo soul",
  "neo-bop jazz",
  "neo-classical metal",
  "neo-medieval",
  "neo-progressive rock",
  "neo-psychedelia",
  "neo-swing",
  "neoclassical",
  "neoclassical dark wave",
  "neoclassical metal",
  "neoclassical new age",
  "neofolk",
  "neotraditional country",
  "nepalese",
  "nerdcore",
  "neue deutsche härte",
  "neue deutsche todeskunst",
  "neue deutsche welle",
  "neurofunk",
  "neurohop",
  "new beat",
  "new jack swing",
  "new jersey hip hop",
  "new orleans blues",
  "new prog",
  "new rave",
  "new romanticism",
  "new school hip hop",
  "new taiwanese song",
  "new wave",
  "new wave of new wave",
  "new weird america",
  "new york blues",
  "new york city",
  "new-age",
  "new-age music",
  "nintendocore",
  "nisiotika",
  "nitzhonot",
  "no wave",
  "noh",
  "noise",
  "noise pop",
  "noise rock",
  "noisegrind",
  "nordic folk",
  "nordic folk dance",
  "nortec",
  "norteño",
  "northern soul",
  "novelty ragtime",
  "nu gaze",
  "nu jazz",
  "nu metal",
  "nu skool breaks",
  "nu-disco",
  "nu-funk",
  "nu-gaze",
  "nu-nrg",
  "nueva canción",
  "obscuro",
  "ocean grunge",
  "oi!",
  "old school hip hop",
  "old time radio",
  "old-time",
  "oldies",
  "olonkho",
  "ondo",
  "opera",
  "operatic pop",
  "operetta",
  "oratorio",
  "orchestra",
  "orchestral jazz",
  "orchestras",
  "organ trio",
  "organic ambient",
  "organum",
  "oriental metal",
  "original pilipino music",
  "ottava rima",
  "ottoman military band",
  "outlaw country",
  "outsider house",
  "outsider music",
  "p-funk",
  "pagan metal",
  "pagan rock",
  "pagode",
  "paisley underground",
  "palm wine",
  "palm-wine",
  "pambiche",
  "panambih",
  "panchai baja",
  "panchavadyam",
  "pansori",
  "paranda",
  "parang",
  "parliament",
  "parody",
  "parranda",
  "partido alto",
  "pasillo",
  "patriotic",
  "pbr&b",
  "peace punk",
  "pelimanni music",
  "pennsylvania",
  "persian traditional music",
  "peruvian cumbia",
  "petenera",
  "peyote song",
  "philadelphia",
  "philadelphia soul",
  "philippines",
  "piano blues",
  "piedmont blues",
  "pimba",
  "pinoy pop",
  "pinoy rock",
  "pinpeat orchestra",
  "piphat",
  "pirate metal",
  "piyyutim",
  "plainchant",
  "plena",
  "pleng phua cheewit",
  "pleng thai sakorn",
  "political hip hop",
  "polka",
  "polo",
  "polonaise",
  "pols",
  "polska",
  "polyphonic",
  "pong lang",
  "pop",
  "pop folk",
  "pop music",
  "pop punk",
  "pop rap",
  "pop rock",
  "pop soul",
  "pop sunda",
  "popera",
  "popular",
  "pornocore",
  "porro",
  "post-bop",
  "post-britpop",
  "post-disco",
  "post-dubstep",
  "post-grunge",
  "post-hardcore",
  "post-industrial",
  "post-metal",
  "post-minimalism",
  "post-punk",
  "post-punk revival",
  "post-rock",
  "post-romanticism",
  "pow-wow",
  "powada",
  "power duo",
  "power electronics",
  "power metal",
  "power noise",
  "power pop",
  "power trio",
  "powerviolence",
  "ppongtchak",
  "praise song",
  "program symphony",
  "progressive",
  "progressive bluegrass",
  "progressive country",
  "progressive electronic music",
  "progressive folk",
  "progressive folk music",
  "progressive house",
  "progressive metal",
  "progressive pop",
  "progressive rock",
  "progressive trance",
  "protest song",
  "protopunk",
  "psybient",
  "psychedelia",
  "psychedelic",
  "psychedelic folk",
  "psychedelic music",
  "psychedelic pop",
  "psychedelic rock",
  "psychedelic trance",
  "psychobilly",
  "psychobilly punkabilly",
  "pub rock (australia)",
  "pub rock (united kingdom)",
  "puerto rican",
  "pungmul",
  "punk",
  "punk blues",
  "punk cabaret",
  "punk jazz",
  "punk rock",
  "punta",
  "punta rock",
  "qasidah",
  "qasidah modern",
  "qawwali",
  "quadrille",
  "quan ho",
  "queercore",
  "quiet storm",
  "r&b",
  "r&b and soul",
  "raga",
  "raga rock",
  "ragga",
  "ragga jungle",
  "raggacore",
  "raggamuffin",
  "ragini",
  "ragtime",
  "rai",
  "raicore",
  "rake-and-scrape",
  "ramkbach",
  "ramvong",
  "ranchera",
  "rap",
  "rap metal",
  "rap music",
  "rap opera",
  "rap rock",
  "rapcore",
  "rapso",
  "rara",
  "rara tech",
  "rare groove",
  "rasin",
  "rasiya",
  "ravana",
  "ravanahatha",
  "rave",
  "raï",
  "raï'n'b",
  "reactionary bluegrass",
  "rebetiko",
  "red dirt",
  "red dirt (music)",
  "red river delta",
  "reel",
  "reggae",
  "reggae español spanish reggae",
  "reggae fusion",
  "reggae highlife",
  "reggaestep",
  "reggaeton",
  "regional mexican",
  "rekilaulu",
  "religious",
  "religious music",
  "rembetiko",
  "renaissance music",
  "requiem",
  "retro",
  "rhapsody",
  "rhumba",
  "rhyming spiritual",
  "rhythm and blues",
  "ricercar",
  "rio de janeiro",
  "riot grrrl",
  "rock",
  "rock and roll",
  "rock en español",
  "rock in opposition",
  "rock music",
  "rock opera",
  "rockabilly",
  "rocksteady",
  "rococo",
  "romantic period in music",
  "ronggeng",
  "roots reggae",
  "roots rock",
  "roots rock reggae",
  "rumba",
  "russian pop",
  "rímur",
  "sabar",
  "sacred harp",
  "sadcore",
  "saibara",
  "sakara",
  "salegy",
  "salsa",
  "salsa erotica",
  "salsa music",
  "salsa romantica",
  "salsa romántica",
  "saltarello",
  "samba",
  "samba rock",
  "samba-canção",
  "samba-reggae",
  "samba-rock",
  "sambai",
  "sambass",
  "sanjo",
  "sardana",
  "sato kagura",
  "sawt",
  "saya",
  "schlager",
  "schottisch",
  "scottish",
  "scottish baroque music",
  "screamo",
  "scrumpy and western",
  "scuff",
  "sea shanty",
  "sean nós",
  "seapunk",
  "second viennese school",
  "sega",
  "sega music",
  "seggae",
  "seis",
  "semba",
  "senegal",
  "sephardic music",
  "serialism",
  "sertanejo",
  "set dance",
  "sevdalinka",
  "sevillana",
  "shabad",
  "shalako",
  "shan'ge",
  "shangaan electro",
  "shango",
  "shape note",
  "shibuya-kei",
  "shidaiqu",
  "shima-uta",
  "shock rock",
  "shoegaze",
  "shoka",
  "shomyo",
  "show tune",
  "sica",
  "siguiriyas",
  "silat",
  "sinawi",
  "singer-songwriter",
  "ska",
  "ska jazz",
  "ska punk",
  "skald",
  "skate punk",
  "skiffle",
  "skullstep",
  "skweee",
  "slack-key guitar",
  "slide",
  "slowcore",
  "sludge metal",
  "slängpolska",
  "smooth jazz",
  "snap music",
  "soca",
  "soft rock",
  "son",
  "son cubano",
  "son montuno",
  "son-batá",
  "sonata",
  "songo",
  "songo-salsa",
  "sophisti-pop",
  "soukous",
  "soul",
  "soul blues",
  "soul jazz",
  "soul music",
  "soundtrack",
  "soundtracks",
  "south and southeast asian",
  "south india",
  "southern gospel",
  "southern harmony",
  "southern hip hop",
  "southern metal",
  "southern rock",
  "southern soul",
  "space age pop",
  "space disco",
  "space music",
  "space rock",
  "spanish",
  "spanish-speaking",
  "spectralism",
  "speed garage",
  "speed metal",
  "speedcore",
  "spirituals",
  "spouge",
  "sprechgesang",
  "square dance",
  "st. louis blues",
  "st. louis hip hop",
  "steelband",
  "stoner metal",
  "stoner rock",
  "straight edge",
  "straight-ahead jazz",
  "strathspeys",
  "street bass",
  "street punk",
  "stride",
  "stride jazz",
  "string",
  "string quartet",
  "sufi",
  "sufi music",
  "sufi rock",
  "suite",
  "sundanese",
  "sung poetry",
  "sunshine pop",
  "suomirock",
  "suomisaundi",
  "super eurobeat",
  "surf ballads",
  "surf instrumental",
  "surf music",
  "surf pop",
  "surf rock",
  "swamp blues",
  "swamp pop",
  "swamp rock",
  "swing",
  "swing music",
  "swiss",
  "sygyt",
  "symphonic black metal",
  "symphonic metal",
  "symphonic poem",
  "symphonic rock",
  "symphony",
  "synthpop",
  "synthwave",
  "synthwave (1980s genre)",
  "synthwave (2000s genre)",
  "t'ong guitar",
  "taarab",
  "tagalog",
  "tai tu",
  "taiwanese",
  "taiwanese pop",
  "tala",
  "talempong",
  "talking blues",
  "tambu",
  "tamburitza",
  "tamil christian keerthanai",
  "tango",
  "tanguk",
  "tappa",
  "taqwacore",
  "tarana",
  "tarantella",
  "taranto",
  "tech house",
  "tech trance",
  "techdombe",
  "technical death metal",
  "technical metal",
  "techno",
  "technoid",
  "techstep",
  "techtonik",
  "tecno brega",
  "tecnobrega",
  "teen pop",
  "tejano",
  "tejano music",
  "tekno",
  "tembang sunda",
  "tempo",
  "texas blues",
  "texas country",
  "thai",
  "thai pop",
  "theme music",
  "thillana",
  "third stream",
  "third wave ska",
  "thirty-two-bar form",
  "thrash metal",
  "thrashcore",
  "thumri",
  "tibetan",
  "tibetan pop",
  "tientos",
  "timba",
  "timbila",
  "tin pan alley",
  "tinga",
  "tinku",
  "toeshey",
  "togaku",
  "tohono o'odham",
  "trad jazz",
  "traditional",
  "traditional country music",
  "traditional pop music",
  "trallalero",
  "trance",
  "trance music",
  "trap",
  "trap music",
  "trapstep",
  "tribal house",
  "trikitixa",
  "trinidadian",
  "trip hop",
  "trival",
  "tropical",
  "tropical house",
  "tropical music",
  "tropicalia",
  "tropipop",
  "truck-driving country",
  "tumba",
  "turbo-folk",
  "turkish music",
  "turkish pop",
  "turntablism",
  "tuva throat singing",
  "tuvan throat singing",
  "tuvan throat-singing",
  "twee pop",
  "twin cities hip hop",
  "twist",
  "two tone",
  "twoubadou",
  "táncház",
  "uk funky",
  "uk garage",
  "uk hard house",
  "uk hardcore",
  "uk pub rock",
  "unblack metal",
  "underground hip hop",
  "underground music",
  "united states",
  "uplifting trance",
  "urban cowboy",
  "urban folk",
  "urban pasifika",
  "v-pop",
  "vallenato",
  "vaporwave",
  "vaudeville",
  "venezuelan",
  "verbunkos",
  "verismo",
  "video game music",
  "vietnamese",
  "viking metal",
  "villanella",
  "virelais",
  "vispop",
  "visual kei",
  "visual music",
  "vocal house",
  "vocal jazz",
  "vocal music",
  "vocal trance",
  "vocaloid",
  "volksmusik",
  "vomitstep",
  "waila",
  "waltz",
  "wangga",
  "war metal",
  "warabe uta",
  "wassoulou",
  "wedding",
  "were music",
  "west african",
  "west coast blues",
  "west coast hip hop",
  "west coast jazz",
  "west country",
  "western blues",
  "western swing",
  "westernmost",
  "whistling",
  "witch house",
  "wizard rock",
  "women's music",
  "wong shadow",
  "wonky",
  "wonky pop",
  "wood",
  "work song",
  "world fusion",
  "world music",
  "worldbeat",
  "xhosa music",
  "xoomii",
  "xote",
  "yakut",
  "yass",
  "yayue",
  "yo-pop",
  "yodeling",
  "youth crew",
  "yukar",
  "yé-yé",
  "zajal",
  "zamrock",
  "zapin",
  "zarzuela",
  "zef",
  "zeibekiko",
  "zeuhl",
  "ziglibithy",
  "zouglou",
  "zouk",
  "zouk-lambada",
  "zouklove",
  "zulu music",
  "zydeco",
  "čalgija"
]

export default {
  Genres,
}